import '../../App.css';

function AlmacenMascotasPoliticasPage() {
  return (
    <div style={{
      padding: '20px',
    }}>
      <h1>Política de Privacidad</h1>
      <p>Última actualización: 15 de septiembre de 2025</p>
      <p>Esta Política de Privacidad y Términos y Condiciones describe nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de su información cuando utiliza Almacén de Mascotas, así como las condiciones de compra y uso del servicio.</p>
      <p><strong>Almacén de Mascotas</strong> no recopila datos personales ni accede a internet. Al usar el Servicio, usted acepta esta política y los siguientes términos y condiciones:</p>

      <h2>1. Generalidades</h2>
      <ul>
        <li>Al realizar una compra en Almacén de Mascotas, usted acepta estos términos y condiciones en su totalidad.</li>
        <li>Nos reservamos el derecho de modificar estos términos en cualquier momento, sin previo aviso.</li>
      </ul>

      <h2>2. Productos</h2>
      <ul>
        <li>Todos los productos están sujetos a disponibilidad.</li>
        <li>Las imágenes son referenciales. El producto final puede presentar variaciones menores.</li>
        <li>Los productos para mascotas deben ser usados según la edad, tamaño y características del animal. Almacén de Mascotas no se responsabiliza por el mal uso de los productos adquiridos.</li>
      </ul>

      <h2>3. Precios y Pagos</h2>
      <ul>
        <li>Todos los precios están expresados en moneda local e incluyen IVA, salvo que se indique lo contrario.</li>
        <li>Aceptamos pagos en efectivo, tarjetas de crédito/débito y medios electrónicos autorizados.</li>
        <li>Las promociones y descuentos no son acumulables salvo indicación expresa.</li>
      </ul>

      <h2>4. Cambios y Devoluciones</h2>
      <ul>
        <li>Se aceptan cambios dentro de los 7 días hábiles posteriores a la compra, presentando la factura original y el producto sin uso, en su empaque original.</li>
        <li>No se aceptan cambios en productos de higiene, alimentación, medicamentos o personalizados, salvo defecto de fábrica.</li>
        <li>Las devoluciones se gestionan únicamente por productos con fallas comprobables de origen.</li>
      </ul>

      <h2>5. Entregas y Envíos</h2>
      <ul>
        <li>Los envíos a domicilio se realizan bajo coordinación previa, según disponibilidad de zonas y horarios.</li>
        <li>El cliente es responsable de brindar una dirección válida y de estar presente en el horario acordado.</li>
        <li>En caso de no concretarse la entrega por ausencia, se reprogramará con costo adicional.</li>
      </ul>

      <h2>6. Responsabilidad</h2>
      <ul>
        <li>Almacén de Mascotas no será responsable por daños indirectos, incidentales o consecuenciales derivados del uso o mal uso de los productos vendidos.</li>
      </ul>

      <h2>7. Atención al Cliente</h2>
      <ul>
        <li>Para cualquier consulta o reclamo, podés comunicarte con nosotros a través de:</li>
        <li>Teléfono: +595 983 787684</li>
        <li>Email: info@almacendemascotas.com.py</li>
        <li>Dirección: Denis Roa Esq. Olegario Andrade - Asunción</li>
      </ul>
    </div>
  );
}

export default AlmacenMascotasPoliticasPage;